export default function PublicCtaSection({ children, className = "" }) {
  return (
    <section
      data-testid="public-cta"
      className={`bg-gradient-to-b from-[#13294b] via-[#10213d] to-[#0b1327] ${className}`.trim()}
    >
      {children}
    </section>
  );
}
